
<template>
    <aside class="filters">
        <FilterFacet
            v-for="filter in filters"
            :key="`facet-group-${filter.name}`"
            v-bind="filter"
        />
    </aside>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { kebabToTitle } from '@/helpers'

export default {
    props: {
        // because our "categories" are use for tabs, we want to hide them unless "ALL results" are dumped
        hideCategories: { type: Boolean, default: true }
    },

    data() {
        return {
            filters: null,
        }
    },

    mounted () {
        this.generateFilters()
    },

    computed: {
        ...mapState('Resources', ['searchResults', 'facets']),
    },

    methods: {
        ...mapActions('Resources', ['buildGlobalFilters']),

        generateFilters () {
            // First we need just the list of "facet" names from the facet objects, we'll use this to
            // filter out what value the we need to assign in the next reduce function
            const facetNames = this.facets.reduce((acc, fac) => {
                return [ ...acc, fac.name ]
            }, [])

            // this generates all the filter objects to filter the actual resources.
            // we do this so we can have one source of truth of "facets"
            this.buildGlobalFilters(facetNames)

            // For every result...
            const filters = this.searchResults.reduce((acc, result) => {

                // then get only the 'facet' values we need from the result, ie we aren't filtering title,
                // so we don't need the result title
                facetNames.forEach(facet => {
                    // get the facet obj index for each (ie, the area facet in this.facets is index of 0)
                    const facetIndex = this.facets.findIndex(({ name }) => name === facet)
                    const accIndex = acc[facetIndex]
                    // check if that facets options already contains the value...
                    // const doesNotHaveFacet = !accIndex.options.includes(result[facet]) && result[facet]
                    const filteredOptions = accIndex.options.filter(({ value }) => value === result[facet])
                    const doesNotHaveFacet = filteredOptions.length === 0 && result[facet]
                    // if not, assign the value, ie "group: aetiology"
                    if (doesNotHaveFacet) accIndex.options = [ ...accIndex.options, { value: result[facet], label: kebabToTitle(result[facet]) } ]
                })

                return acc
            }, this.facets) // we reference the stores facets object so we can easily "update" the list in future if need be

            // sort the filters by order object...
            const sortedFilters = filters.sort((a, b) => (a.order - b.order))
            this.hideCategories
                ? this.filters = sortedFilters.filter(({ name }) => name !== 'category')
                : this.filters = sortedFilters
        }
    }
}
</script>

